export interface PayloadOutputSchema {
  id: string;
  allowedKeys: readonly string[];
  requiredKeys?: readonly string[];
  /** Optional typed parser (for example, Zod) used as canonical payload validation. */
  parser?: (payload: Record<string, unknown>) => Record<string, unknown>;
}

const payloadSchemas = new Map<string, PayloadOutputSchema>();

export function registerPayloadSchema(schema: PayloadOutputSchema): void {
  payloadSchemas.set(schema.id, schema);
}

export function getPayloadSchema(id: string): PayloadOutputSchema | undefined {
  return payloadSchemas.get(id);
}

export function hasPayloadSchema(id: string): boolean {
  return payloadSchemas.has(id);
}
